import {
  ISharedFileRequestResponse,
  SharedFileRequestStatus
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";
import { selectorSharedFileReUploadAttempts } from "./selectorSharedFileReUploadAttempts";
import { MAX_COI_FILE_UPLOAD_ATTEMPTS } from "../modules/SharedFile/configs/utils";

export function selectorIsSharedFileReUploadAvailable(
  sharedFile: ISharedFileRequestResponse | undefined
): boolean {
  return (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.PendingSubmission &&
    selectorSharedFileReUploadAttempts(sharedFile) <
      MAX_COI_FILE_UPLOAD_ATTEMPTS
  );
}
